export default theme => {
  return {
    container: {
      marginBottom: 25
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/selection/SetBuilder/SetBuilderToolbar.js